import React from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import { getImageUrl, getStaticImageUrl, SOURCES, MIN_WIDTH } from 'client/utils/image-helpers';
import { INVENTORY_TYPES_LOWERCASE } from 'client/constants/inventory-types';
import { NO_VEHICLE_GRAY_IMAGE_SEDAN } from 'site-modules/shared/constants/images';
import { getDealerDetailsSearchResultsUrl } from 'site-modules/shared/utils/dealerships/dealer-inventory';
import { DealerDetailsSearchResultsElement } from 'site-modules/dealerships/components/dealer-details-search-results-element/dealer-details-search-results-element';
import { Link } from 'site-modules/shared/components/link/link';

import './dealer-inventory-carousel-item.scss';

export function DealerInventoryCarouselItem({ makeModel, locationId, isHidden }) {
  const makeModelTrackingValue = `${makeModel.make}_${makeModel.model}`.toLowerCase();
  const { NEW, USED, CPO } = INVENTORY_TYPES_LOWERCASE;
  return (
    <div className="dealer-inventory-carousel-item h-100 rounded-12 bg-white mx-0_75 d-flex flex-column overflow-hidden">
      <div className="item-photo-container mx-auto w-100">
        <img
          alt=""
          className="img-fluid"
          src={
            makeModel.thumbnailUrl
              ? getImageUrl(makeModel.thumbnailUrl, MIN_WIDTH, SOURCES.STATIC)
              : getStaticImageUrl(NO_VEHICLE_GRAY_IMAGE_SEDAN)
          }
        />
      </div>
      <div className="d-flex justify-content-between flex-column flex-1 p-1">
        <div>
          <h3 className="size-20 text-cool-gray-10 mb-1">
            {makeModel.make} {makeModel.model}
          </h3>
          <ul className="list-unstyled">
            {makeModel.counts[NEW] > 0 && (
              <li className="mb-1">
                <DealerDetailsSearchResultsElement
                  isHidden={isHidden}
                  locationId={locationId}
                  inventoryType={NEW}
                  makeModel={makeModel}
                  data-tracking-value={`${NEW} ${makeModelTrackingValue}`}
                  className="text-underline"
                >
                  {makeModel.counts[NEW]} {NEW}
                </DealerDetailsSearchResultsElement>
              </li>
            )}
            {makeModel.counts[USED] > 0 && (
              <li className="mb-1">
                <DealerDetailsSearchResultsElement
                  isHidden={isHidden}
                  locationId={locationId}
                  inventoryType={USED}
                  makeModel={makeModel}
                  data-tracking-value={`${USED} ${makeModelTrackingValue}`}
                  className="text-underline"
                >
                  {makeModel.counts[USED]} {USED}
                </DealerDetailsSearchResultsElement>
              </li>
            )}
            {makeModel.counts[CPO] > 0 && (
              <li className="mb-1">
                <DealerDetailsSearchResultsElement
                  isHidden={isHidden}
                  locationId={locationId}
                  inventoryType={CPO}
                  makeModel={makeModel}
                  data-tracking-value={`${CPO} ${makeModelTrackingValue}`}
                  className="text-underline"
                >
                  {makeModel.counts[CPO]} certified pre-owned
                </DealerDetailsSearchResultsElement>
              </li>
            )}
          </ul>
        </div>
        <Button
          color="blue-50"
          className="show-inv-btn fw-medium mt-0_5 w-100 text-transform-none rounded-8 size-16"
          tag={Link}
          to={getDealerDetailsSearchResultsUrl(locationId, '', makeModel)}
          data-tracking-id="ddp_view_search_result"
          data-tracking-value={`all ${makeModelTrackingValue}`}
          tabIndex={isHidden ? -1 : null} // when this element is hidden via aria-hidden on a parent, then we need to remove tabindex so you can't tab to it.
        >
          Show Inventory
        </Button>
      </div>
    </div>
  );
}

DealerInventoryCarouselItem.propTypes = {
  makeModel: PropTypes.shape({
    make: PropTypes.string.isRequired,
    model: PropTypes.string.isRequired,
    thumbnailUrl: PropTypes.string,
    counts: PropTypes.shape({
      new: PropTypes.number,
      cpo: PropTypes.number,
      used: PropTypes.number,
    }),
  }).isRequired,
  locationId: PropTypes.number.isRequired,
  isHidden: PropTypes.bool,
};

DealerInventoryCarouselItem.defaultProps = {
  thumbnailUrl: '',
  makeModel: {
    counts: {
      new: 0,
      cpo: 0,
      used: 0,
    },
  },
  isHidden: false,
};
